import { Navigate, Outlet } from 'react-router';
import {
  AuthorizedOutletContext,
  useAuthorizedOutletContext,
  // usePathParams,
} from '@/true-fsd/data/advertiser-account';
import { getHistoryTree } from '../history-store/history-tree-store';

// const NewAccountOutlet = ({
//     context,
// }: {
//     context: NewAccountOutletContext
// }) => <OutletUntyped context={context} />

// export const NewAccountGuard = () => {
//     const context = useUserOutletContext()

//     if (!isNewAccountOutletContext(context)) {
//         //this should normally never happen
//         console.error('UserWithNewAccountContext')
//         return <Navigate to="/" />
//     }

//     return <NewAccountOutlet context={context} />
// }

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export const OutletContextTypeGuard = <Ctx extends AuthorizedOutletContext>({
  typeGuard,
}: {
  typeGuard: (v: AuthorizedOutletContext) => v is Ctx;
}) => {
  const context = useAuthorizedOutletContext();
  // const pp = usePathParams();

  if (!typeGuard(context)) {
    //may happen if navigate to invalid path or non-existent account or workspace
    console.error('OutletContextTypeGuard');
    // console.log(context, window.location, pp);
    getHistoryTree().reset();
    return <Navigate to="/" />;
  }

  return <Outlet context={context} />;
};
